import * as React from 'react';

import { PaginationLink, IPaginationOnClickParams } from './PaginationLink';
import { PaginationItem } from './PaginationItem';
import { UIText1 } from '@cian/ui-kit';
import { PaginationContainer } from './PaginationContainer';
import { getArrayOfPages, isCurrentPage, getText } from './utils';

interface IPaginationProps {
  currentPage: number;
  maxPage: number;
  urlCreator(page: number): string;
  onClick(params: IPaginationOnClickParams): void;
}

export const Pagination: React.FC<IPaginationProps> = ({ currentPage, maxPage, urlCreator, onClick }) => {
  const arrayOfPages = getArrayOfPages(currentPage, maxPage);

  const handleClick = (params: IPaginationOnClickParams) => {
    if (onClick) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      onClick(params);
    }
  };

  return (
    <PaginationContainer>
      {arrayOfPages.map((pageNumber: number) => (
        <PaginationItem key={pageNumber} isCurrentPage={isCurrentPage(pageNumber, currentPage)}>
          {isCurrentPage(pageNumber, currentPage) ? (
            <UIText1>{getText(pageNumber, currentPage, maxPage)}</UIText1>
          ) : (
            <PaginationLink pageNumber={pageNumber} url={urlCreator(pageNumber)} onClick={handleClick}>
              {getText(pageNumber, currentPage, maxPage)}
            </PaginationLink>
          )}
        </PaginationItem>
      ))}
    </PaginationContainer>
  );
};
